// extracted by mini-css-extract-plugin
export default {"input-field":"styles_input-field__sLNdS","label":"styles_label__0DeM2","input":"styles_input__+RlLh","error":"styles_error__enwo5"};